export const ExpertPostingPrintSlip = ({
  className = '',
  performer,
  account = {},
  postedList = [],
  payouts = [],
  printedBy,
}) => {
  const printedAt = new Date().toLocaleString('en-GB', {
    day: '2-digit', month: 'short', year: 'numeric', hour: '2-digit', minute: '2-digit', hour12: true,
  });

  const currentDate = new Date().toLocaleDateString('en-GB');

  // ভাউচার নম্বর
  const rawName = performer?.label
    ? performer.label.split(' ')[0].replace(/[^a-zA-Z]/g, '').toUpperCase()
    : 'EXP';
  const dateStr = new Date().toISOString().slice(0, 10).replace(/-/g, '');
  const voucherNo = `EP-${dateStr}-${rawName}`;

  const currentMonthYear = new Date().toLocaleString('en-GB', { month: 'short', year: 'numeric' });
  const periodText = `01–30 ${currentMonthYear}`;

  const totalCommission = Number(
    account.totalEarned ?? postedList.reduce((s, r) => s + (Number(r.commissionAmount) || 0), 0)
  );
  const totalPaid = Number(
    account.totalPaid ?? payouts.reduce((s, p) => s + (Number(p.amount) || 0), 0)
  );
  const netPayable = Number(account.balanceDue ?? (totalCommission - totalPaid));

  // সর্বশেষ পেআউট যিনি সম্পন্ন করেছেন
  const lastPayout = payouts && payouts.length > 0 ? payouts[payouts.length - 1] : null;
  const actualPaidBy = lastPayout?.paidByUserName || printedBy || 'Staff';
  const receiverName = performer?.label ? performer.label.split(' (')[0] : 'Doctor';

  return (
    <div className={`${className} hidden`}>
      <style>{`
        @media print {
          @page { size: 162mm 229mm; margin: 0; }
          html, body { margin: 0 !important; padding: 0 !important; }
          body * { visibility: hidden; }
          .${className}, .${className} * { visibility: visible; }
          .${className} { display: block !important; position: absolute; left: 0; top: 0; width: 162mm; }
          .${className} * { color: #000 !important; }

          .pv-slip { display: flex; flex-direction: column; min-height: 229mm; box-sizing: border-box; padding: 8mm 9mm; font-family: Arial, sans-serif; font-size: 9pt; position: relative; }
          .pv-body { flex: 1 0 auto; }

          .pv-header { text-align: center; border-bottom: 2px solid #000; padding-bottom: 6px; margin-bottom: 8px; }
          .pv-name { font-size: 17pt; font-weight: 800; }
          .pv-addr { font-size: 8pt; margin-top: 2px; }
          .pv-title { text-align: center; font-size: 13pt; font-weight: 800; letter-spacing: 1px; text-transform: uppercase; margin: 6px 0 10px; }

          .pv-meta { display: flex; justify-content: space-between; font-size: 9.5pt; margin-bottom: 4px; }
          .pv-meta strong { font-weight: 700; }
          .pv-holder { display: flex; justify-content: space-between; font-size: 9.5pt; margin-bottom: 10px; }

          .pv-slip table { width: 100%; border-collapse: collapse; margin-bottom: 10px; }
          .pv-slip th, .pv-slip td { border: 1px solid #000; padding: 4px 7px; font-size: 9pt; line-height: 1.25; }
          .pv-slip th { background: #e6e6e6 !important; -webkit-print-color-adjust: exact !important; print-color-adjust: exact !important; font-weight: 700; text-align: left; }
          .pv-slip td.num, .pv-slip th.num { text-align: right; }
          .pv-slip td.ctr, .pv-slip th.ctr { text-align: center; }

          .pv-totals { width: 60%; margin-left: auto; font-size: 9.5pt; margin-top: 6px; }
          .pv-totals > div { display: flex; justify-content: space-between; padding: 2px 0; border-bottom: 1px dotted #999; }
          .pv-totals > div.net { font-weight: 800; font-size: 11pt; border-top: 2px solid #000; border-bottom: none; margin-top: 3px; padding-top: 4px; }

          .pv-bottom { flex-shrink: 0; }
          .pv-sign { display: flex; justify-content: space-between; margin-bottom: 12px; font-size: 9pt; }
          .pv-sign > div { width: 42%; text-align: center; }
          .pv-sign .sign-space { height: 34px; }
          .pv-sign .line { border-top: 1.5px solid #000; margin: 0 8px 4px; }
          .pv-sign .role { font-weight: 700; font-size: 9pt; letter-spacing: 0.3px; }
          .pv-sign .sub { font-size: 7pt; color: #555 !important; margin-top: 1px; }

          .pv-footer { text-align: center; font-size: 7pt; margin-top: 8px; border-top: 1px solid #ccc; padding-top: 4px; }

          .pv-slip::before { content: "Mukti Hospital"; position: fixed; top: 50%; left: 50%; transform: translate(-50%,-50%) rotate(-40deg); font-size: 46pt; font-weight: 800; color: rgba(0,0,0,0.04); z-index: -1; white-space: nowrap; }
        }
      `}</style>

      <div className="pv-slip">
        <div className="pv-body">
          <div className="pv-header">
            <div className="pv-name">Mukti Hospital</div>
            <div className="pv-addr">Race Course, Sasongacha, Cumilla</div>
            <div className="pv-addr">Pathology: 01673-625038 &nbsp;·&nbsp; Emergency: 01711-796905</div>
          </div>

          <div className="pv-title">Expert Posting Voucher</div>

          <div className="pv-meta">
            <span><strong>Voucher No:</strong> {voucherNo}</span>
            <span><strong>Date:</strong> {currentDate}</span>
          </div>

          <div className="pv-holder">
            <span><strong>Account Holder:</strong> {performer?.label || 'N/A'}</span>
            <span><strong>Period:</strong> {periodText}</span>
          </div>

          <table>
            <thead>
              <tr>
                <th className="ctr" style={{ width: '8%' }}>SL</th>
                <th style={{ width: '18%' }}>Date</th>
                <th style={{ width: '22%' }}>Bill No</th>
                <th style={{ width: '24%' }}>Patient</th>
                <th style={{ width: '16%' }}>Test</th>
                <th className="num" style={{ width: '12%' }}>Commission</th>
              </tr>
            </thead>
            <tbody>
              {postedList.length === 0 ? (
                <tr><td colSpan={6} className="ctr">No records</td></tr>
              ) : (
                postedList.map((row, i) => (
                  <tr key={row.id || i}>
                    <td className="ctr">{i + 1}</td>
                    <td>
                      {row.createdAt
                        ? new Date(row.createdAt).toLocaleDateString('en-GB')
                        : row.postedAt
                        ? new Date(row.postedAt).toLocaleDateString('en-GB')
                        : 'N/A'}
                    </td>
                    <td style={{ fontWeight: 600 }}>{row.billNumber}</td>
                    <td style={{ textTransform: 'capitalize' }}>{row.patientName || 'N/A'}</td>
                    <td>{row.testName}</td>
                    <td className="num">{(Number(row.commissionAmount) || 0).toFixed(2)}</td>
                  </tr>
                ))
              )}
            </tbody>
          </table>

          <div className="pv-totals">
            <div>
              <span>Total Commission:</span>
              <span>৳ {totalCommission.toFixed(2)}</span>
            </div>
            <div>
              <span>Total Paid:</span>
              <span>৳ {totalPaid.toFixed(2)}</span>
            </div>
            <div className="net">
              <span>Net Payable:</span>
              <span>৳ {netPayable.toFixed(2)}</span>
            </div>
          </div>
        </div>

        <div className="pv-bottom">
          <div className="pv-sign">
            <div>
              <div className="sign-space"></div>
              <div className="line"></div>
              <div className="role">Paid By</div>
              <div className="sub">{actualPaidBy}</div>
            </div>
            <div>
              <div className="sign-space"></div>
              <div className="line"></div>
              <div className="role">Received By</div>
              <div className="sub">{receiverName}</div>
            </div>
          </div>
          <div className="pv-footer">
            Printed: {printedAt} &nbsp;|&nbsp; Software Powered By: Microters · microters.com
          </div>
        </div>
      </div>
    </div>
  );
};